module.exports = __webpack_public_path__ + "media/images/icons/hash-cefb90db578cc2fd6238a7a925979a02.svg";